import { render, staticRenderFns } from "./BookingButton.vue?vue&type=template&id=395ca884"
import script from "./bookingButton.ts?vue&type=script&lang=js&external"
export * from "./bookingButton.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports